.table {
	width: fit-content;
	max-width: 100%;
	border-collapse: separate;
	border-spacing: 0;
	border: var(--size-border) solid var(--color-border);
	border-radius: var(--radius-sm);
	overflow-wrap: anywhere;

	& > tbody > tr > * {
		padding: var(--size-2) var(--size-4);
		text-align: start;
		vertical-align: baseline;
	}

	& > tbody > tr:not(:last-child) > * {
		border-block-end: var(--size-border) solid var(--color-border);
	}

	& > tbody > tr > th {
		box-sizing: border-box;
		min-width: var(--detail-label-width, 10rem);
		border-inline-end: var(--size-border) solid var(--color-border);
		font-weight: 500;
		color: var(--color-text-subtle);
		white-space: nowrap;
	}
}

.stack {
	display: flex;
	flex-direction: column;
	gap: var(--size-3);
}

.empty {
	color: var(--color-text-subtle);
}
